import React, { useState, useEffect, useCallback } from 'react'
import { string } from 'prop-types'
import Input from '@active/react-ui/Input'
import { withI18n } from '@active/react-utils/i18n'
import { appendScript } from '../../../shared/utils/commonUtils'
import { show, hide } from '../../../shared/utils/spinnerUtils'

import './Captcha.scss'

const Captcha = withI18n(props => {
  const {
    recaptchaUrl,
    recaptchaSiteKey,

    name,
    value,
    required,
    onChange,
    onBlur,
    registerValidate,
    htmlForm,
    onTouched,
    hasError,
  } = props

  const [inputValue, setInputValue] = useState(value)

  useEffect(() => {
    show()

    const loadToken = () => {
      hide()
      setInputValue('true')
      onChange && onChange('true')
    }

    appendScript({
      src: `${recaptchaUrl}?render=${recaptchaSiteKey}`,
      onload: loadToken,
      alreadyLoad: loadToken,
      async: true,
    })
  }, [onChange, recaptchaSiteKey, recaptchaUrl])

  const handleChange = useCallback(({ target: { value: newValue } }) => {
    setInputValue(newValue)
    onChange && onChange(newValue)
  }, [onChange])

  return (
    <div className="passport-captcha">
      <Input
        readOnly
        id={name}
        name={name}
        required={required}
        onChange={handleChange}
        onBlur={onBlur}
        registerValidate={registerValidate}
        htmlForm={htmlForm}
        onTouched={onTouched}
        hasError={hasError}
        value={inputValue}
        autoComplete="off"
      />
    </div>
  )
})

Captcha.propTypes = {
  recaptchaUrl: string.isRequired,
  recaptchaSiteKey: string.isRequired,
}

Captcha.defaultProps = {}

export default Captcha
